import script from "./stdOnboardingFirstPage.vue?vue&type=script&setup=true&lang=js"
export * from "./stdOnboardingFirstPage.vue?vue&type=script&setup=true&lang=js"

import "./stdOnboardingFirstPage.vue?vue&type=style&index=0&id=020d66ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-020d66ff"]])

export default __exports__